import { XDP_PRODUCT_TYPES } from 'bundles/search-common/constants/entityTypes';
import type { SearchProductHit } from 'bundles/search-common/providers/searchTypes';
import getXDPPageLink from 'bundles/unified-description-page-common/utils/getXDPPageLink';

const getProductPageUrlFromHit = ({
  hit,
  shouldUseSubfolderLinksForXDP,
  subfolderLocaleCode,
}: {
  hit: SearchProductHit;
  shouldUseSubfolderLinksForXDP: boolean;
  subfolderLocaleCode?: string;
}) => {
  if (hit?.productType && hit?.url && XDP_PRODUCT_TYPES.includes(hit.productType) && shouldUseSubfolderLinksForXDP) {
    return getXDPPageLink({ productPageUrlPath: hit.url, subfolderLocaleCode });
  }

  return hit?.url ?? undefined;
};

export default getProductPageUrlFromHit;
